
export interface Customer {
  id?: number;
  email: string;
  name: string;
  phone?: string;
  barId?: string;
  totalSpent?: number;
  createdAt?: string;
  updatedAt?: string;
}
